module.exports = __webpack_public_path__ + "static/fraud-c1342cae1b7e6468097f82381e0a5357.jpg";